module.exports = __webpack_public_path__ + "img/2024Logo.284ad196.png";